import formAppDeveloperOptions from './formGroupAppClientDeveloperOptions';
import formAppAnalyticsConfig from './formGroupAppClientConfigAnalyticsConfig';
import formAppEvaluatorConfig from './formGroupAppClientConfigViewEvaluatorConfig';
import formAppSharedExperiencesConfig from './formGroupAppClientConfigSharedExperiencesConfig';
import tableAppClientConfigCatalog from './tableAppClientConfigCatalog';
import formAppNonDestructiveBuffer from './formGroupAppClientConfigNonDestructiveBuffer';
import formAppLowLatency from './formGroupAppClientConfigLowLatency';
import formAppWebSocket from './formGroupAppClientConfigWebSocket';
import formAppLegacyValues from './formGroupAppClientConfigLegacyValues';
import formGroupAppClientBufferLevels from './formGroupAppClientBufferLevels';
import formGroupAppClientViewportPrediction from './formGroupAppClientViewportPrediction';
import formGroupAppClientSponsor from './formGroupAppClientSponsor';
import formGroupAppClientConfigThirdProvider from './formGroupAppClientConfigThirdProvider';
import formGroupAppClientRecommendations from './formGroupAppClientRecommendations';
export default {
  title: 'Client Parameters',
  attributeName: 'mainHubClientConfig',
  getURL: 'mainHubs/mainHubId/mainHubConfigs/configId/mainHubClientConfig',
  updateURL: 'mainHubs/mainHubId/mainHubConfigs/configId/mainHubClientConfig',
  sessionParams: ['mainHubId','configId'],
  noArea: false,
  isMainHub: true,
  autoUpdate: true,
  formConfig: [
    formGroupAppClientBufferLevels,
    formAppEvaluatorConfig,
    formAppNonDestructiveBuffer,
    formGroupAppClientSponsor,
    formGroupAppClientViewportPrediction,
    formAppAnalyticsConfig,
    formAppSharedExperiencesConfig,
    formAppLowLatency,
    formAppWebSocket,
    formAppDeveloperOptions,
    formAppLegacyValues,
    // formGroupAppClientConfigThirdProvider,
  ],
};
